import { FC, useEffect, useState } from 'react';
import { errorApiRef, useApi } from '@backstage/core-plugin-api';
import { Skeleton } from '@material-ui/lab';
import { CustomLogo } from './CustomLogo';
import { DefaultLogo } from './DefaultLogo';
import { CustomLogoProps } from './types';
import { getCustomLogo } from './utils';

export const Logo: FC = () => {
  const errorApi = useApi(errorApiRef);
  const [loading, setLoading] = useState<boolean>(false);
  const [customLogo, setCustomLogo] = useState<CustomLogoProps | undefined>();

  const loadCustomLogo = () => {
    setLoading(true);
    getCustomLogo()
      .then(custom => {
        if (custom) setCustomLogo(custom);
      })
      .catch(e => {
        errorApi.post(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadCustomLogo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading)
    return (
      <Skeleton style={{ minWidth: '190px' }} width="100%" height="100%" />
    );

  return customLogo ? <CustomLogo customLogo={customLogo} /> : <DefaultLogo />;
};
